<div mat-dialog-title class="justify-content-center align-items-center" style="margin-top: -10px !important;">
    Las siguientes solicitudes ya se encuentran en un remito
</div> 
<div mat-dialog-content style="overflow:unset; font-size: 17px;">
    <ul class="mt-3">
        <li *ngFor="let order of orders"> {{order.orderId}}</li>
    </ul>

    ¿Desea incluirlas o excluirlas en este remito?
<div mat-dialog-footer>
    
</div>
<mat-dialog-actions align="center" class="mt-3" >
    <button mat-raised-button [mat-dialog-close]="null"  color="secondary">Cancelar</button>
    <button mat-raised-button [mat-dialog-close]="false"  color="warn">Excluir</button>
    <button mat-raised-button [mat-dialog-close]="true"  color="primary">Incluir</button>
    
<!--button mat-raised-button [mat-dialog-close]="" (click) color="primary">Si</button-->
</mat-dialog-actions>
